<div class="div-main rtl">
    <div class="page-title-area">
        <div class="container">
            <div class="page-title-content">
                <h1 class="iransans-bold">
                    اطلاعات سلامت
                </h1>
            </div>
        </div>
    </div>
    <mat-drawer-container class="main-container fill" dir="rtl">
        <mat-drawer class="light-blue overflow-x drawer" position="end" [mode]="'side'" [opened]="isOpenDrawer" #drawer>
            <blog-search (closeEvent)="onCloseDrawer()"></blog-search>
        </mat-drawer>
        <mat-drawer-content class="div-flex-vertical overflow-x" autosize>

            <div class="container">
                <div class="div-search-button  div-search-button-lg" *ngIf="!isOpenDrawer" (click)="onOpenDrawer()">
                    <mat-icon style="font-size:40px;margin-bottom: 10px;margin-left:10px;">search</mat-icon>
                </div>
                <div class="div-search-button-sm pt-2">
                    <input type="text" class="form-control font-12 iransans" placeholder="جستجو کنید" (click)="onOpenMobileSearch()" >
                </div>
                <div class="row m-0 my-4">
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let blog of blogsList"
                        [routerLink]="['/drme-blog/blog',blog.code]">
                        <div class="blog-post-card">
                            <div class="position-relative">
                                <img [src]="blog.image" class="w-100 post-image" alt="">
                            </div>
                            <div class="post-content">
                                <h3 class="post-title iransans-bold">
                                    {{blog.title}}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>


</div>